module.exports = __webpack_public_path__ + "static/tabs-buttons-dont-e88df3130a35f3313e982071c9e2bdaf.png";